export default "__VITE_ASSET__CTSIMmoP__"